
import React from 'react';
import history from '../../../history';
import AppTitle from '../../../shared/template/AppTitle';
import { ErrorScreen } from '../../../shared/template/InfoScreen';

const MSG_ERRO = 'Serviço não disponível para o perfil de procurador.';
const TEXTO_COMPLEMENTO = `O representado deve liberar este serviço no Gov.br.`;
const TITULO = 'Página sem acesso';

const ProcuradorAcessoNegado = props => {  
  
  let mensagem = ( props?.msgAcessoProcurador ? props.msgAcessoProcurador : (props?.msg ? props.msg : ''));
  
  return (
    <React.Fragment>
      <AppTitle title={props.title || TITULO} />      
      <ErrorScreen
        primaryText={mensagem ? mensagem : MSG_ERRO}
        secondaryText={(mensagem ? TEXTO_COMPLEMENTO : '')}
        buttonText="Voltar"
        action={() => history.push('/') } 
      />      
    </React.Fragment>
  );
}

export default ProcuradorAcessoNegado;
